import React, { useState } from 'react';

import { getLabels } from '../fieldLabels';

const API_BASE = "https://adria.terrier-ule.ts.net";

export default function NfcRegister() {
  const params   = new URLSearchParams(window.location.search);
  const tenantId = params.get('tenant') || '';
  const template = params.get('template') || 'residential';
  const L        = getLabels(template);

  const [step,   setStep]   = useState('form');
  const [name,   setName]   = useState('');
  const [phone,  setPhone]  = useState('');
  const [roomNo, setRoomNo] = useState('');
  const [tagId,  setTagId]  = useState(null);
  const [status, setStatus] = useState('');

  if (!tenantId) {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '50px', marginBottom: '12px' }}>⚠️</div>
          <h2 style={{ color: '#ef4444', margin: '0 0 8px', fontSize: '17px' }}>잘못된 링크</h2>
          <p style={{ color: '#6b7280', fontSize: '13px', margin: 0 }}>
            관리자에게 올바른 등록 링크를 받아주세요.
          </p>
        </div>
      </div>
    );
  }

  const handleRegister = async () => {
    if (!name || !phone || !roomNo) {
      setStatus(L.required_msg); return;
    }
    setStep('waiting');
    setStatus('등록 정보 확인 중...');

    try {
      const res = await fetch(`${API_BASE}/api/nfc/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-tenant-id': tenantId },
        body: JSON.stringify({ user_name: name, phone, room_no: roomNo }),
      });

      if (res.status === 404) {
        const d = await res.json();
        setStatus('❌ ' + (d.detail || L.not_found_msg));
        setStep('form'); return;
      }
      if (!res.ok) {
        setStatus('❌ 서버 오류가 발생했습니다. 다시 시도해주세요.');
        setStep('form'); return;
      }

      const data = await res.json();
      setTagId(data.tag_id);
      setStatus('📱 준비됐습니다!\nNFC 카드나 태그를 도어락에 태치해주세요.');

      // 폴링 시작
      pollTag(data.tag_id);

    } catch (e) {
      setStatus('❌ 오류: ' + e.message);
      setStep('form');
    }
  };

  const pollTag = async (id) => {
    const messages = [
      '📱 NFC 카드를 도어락에 태치해주세요',
      '⏳ 태그를 기다리는 중이에요...',
      '📡 도어락과 통신 중이에요',
      '⏳ 거의 다 됐어요! 조금만 기다려주세요',
    ];
    for (let i = 0; i < 60; i++) {
      await new Promise(r => setTimeout(r, 1000));
      setStatus(messages[Math.min(Math.floor(i / 8), messages.length - 1)]);
      try {
        const res  = await fetch(`${API_BASE}/api/nfc/tags/${id}/status`, {
          headers: { 'x-tenant-id': tenantId },
        });
        const data = await res.json();
        if (data.registered) {
          setStep('done');
          return;
        }
      } catch (_) {}
    }
    setStatus('❌ 등록 시간이 초과됐습니다. 다시 시도해주세요.');
    setStep('form');
  };

  // ── 완료 화면 ─────────────────────────────────────────────
  if (step === 'done') {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '60px', marginBottom: '16px' }}>✅</div>
          <h2 style={{ color: '#10b981', margin: '0 0 8px' }}>등록 완료!</h2>
          <p style={{ color: '#6b7280', fontSize: '14px', margin: '0 0 8px', lineHeight: '1.7' }}>
            잠시 후 도어락에 자동으로 반영됩니다.<br />
            NFC 카드를 도어락에 터치하면<br />문이 열립니다.
          </p>
          <div style={{ fontSize: '12px', color: '#9ca3af', backgroundColor: '#f9fafb',
                        padding: '8px 12px', borderRadius: '8px' }}>
            {name} · {roomNo}호
          </div>
        </div>
      </div>
    );
  }

  // ── 대기 화면 ─────────────────────────────────────────────
  if (step === 'waiting') {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '60px', marginBottom: '16px', animation: 'pulse 1.5s infinite' }}>📱</div>
          <h2 style={{ color: '#4f46e5', margin: '0 0 12px', fontSize: '17px' }}>NFC 태그 대기 중</h2>
          <p style={{ color: '#374151', fontSize: '14px', margin: '0 0 20px',
                      whiteSpace: 'pre-line', lineHeight: '1.8' }}>
            {status}
          </p>
          <div style={{ fontSize: '12px', color: '#9ca3af', backgroundColor: '#f9fafb',
                        padding: '8px 12px', borderRadius: '8px', marginBottom: '16px' }}>
            {name} · {roomNo}호
          </div>
          <button onClick={() => { setStep('form'); setStatus(''); }}
            style={{ padding: '10px 24px', backgroundColor: '#e5e7eb', color: '#4b5563',
                     border: 'none', borderRadius: '10px', fontSize: '13px', cursor: 'pointer' }}>
            취소
          </button>
        </div>
      </div>
    );
  }

  // ── 등록 폼 ───────────────────────────────────────────────
  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: '40px', marginBottom: '10px' }}>📱</div>
        <h2 style={{ margin: '0 0 4px', color: '#1f2937', fontSize: '18px' }}>NFC 카드 등록</h2>
        <p style={{ margin: '0 0 20px', color: '#6b7280', fontSize: '13px' }}>
          NFC 카드를 도어락에 등록합니다
        </p>

        <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0',
                      borderRadius: '12px', padding: '14px', marginBottom: '20px', textAlign: 'left' }}>
          <p style={{ fontSize: '13px', fontWeight: 'bold', color: '#065f46', margin: '0 0 8px' }}>
            📍 등록 방법
          </p>
          <ol style={{ margin: 0, paddingLeft: '18px', fontSize: '13px',
                       color: '#374151', lineHeight: '1.9' }}>
            <li>아래 정보를 입력해주세요</li>
            <li>등록 버튼을 눌러주세요</li>
            <li>NFC 카드를 도어락에 태치하면 자동 등록됩니다</li>
          </ol>
        </div>

        <input placeholder={L.user_name_ph} value={name}
          onChange={e => setName(e.target.value)} style={inputStyle} />
        <input placeholder={L.phone_ph} value={phone}
          onChange={e => setPhone(e.target.value)} style={inputStyle} type="tel" />
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
          <input placeholder={L.room_no_ph} value={roomNo} type="text"
            onChange={e => setRoomNo(e.target.value.replace(/[^0-9]/g, ''))}
            style={{ ...inputStyle, marginBottom: 0, flex: 1 }} />
          <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#374151' }}>호</span>
        </div>

        {status && (
          <p style={{ fontSize: '13px', color: '#ef4444',
                      margin: '0 0 12px', whiteSpace: 'pre-line', textAlign: 'center' }}>
            {status}
          </p>
        )}

        <button onClick={handleRegister}
          style={{ width: '100%', padding: '14px', backgroundColor: '#4f46e5',
                   color: '#fff', border: 'none', borderRadius: '12px',
                   fontWeight: 'bold', fontSize: '15px', cursor: 'pointer' }}>
          📱 NFC 카드 등록하기
        </button>
      </div>
    </div>
  );
}

const wrap      = { display: 'flex', alignItems: 'center', justifyContent: 'center',
                    minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' };
const card      = { backgroundColor: '#fff', padding: '36px 28px', borderRadius: '20px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%',
                    maxWidth: '360px', textAlign: 'center' };
const inputStyle = { width: '100%', padding: '12px', borderRadius: '10px',
                     border: '1px solid #d1d5db', fontSize: '14px',
                     boxSizing: 'border-box', marginBottom: '10px' };
